$(document).on('ready turbolinks:load', function() {
  $('body').on('change', '.g-calendar-id', function() {
    $('#g-calendar-name').val($(this).siblings('label').text());
  });
})
